import {
  Tag,
  TagBlockProps,
} from '@payfit/growth-platform-brand-system-v2/components/Tag';
import { fontCaption } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import classNames from 'classnames';
import React from 'react';

type SubheaderProps = {
  oBFeesLabel: string;
  oBFeesTag: TagBlockProps;
};

const Subheader = ({ oBFeesLabel, oBFeesTag }: SubheaderProps) => {
  return (
    <div
      className={classNames(
        'PriceBreakdown_Subheader',
        'flex items-center justify-between gap-x-16 gap-y-2',
      )}
    >
      <p className={classNames('text-[#55687D]', fontCaption)}>{oBFeesLabel}</p>
      <Tag color={oBFeesTag?.color}>{oBFeesTag?.title}</Tag>
    </div>
  );
};

export default Subheader;
